import { parsePhoneNumberWithError } from 'libphonenumber-js/max';

export const IDENTIFIER_HELP = 'Enter an email or mobile number. Indian numbers can use 10 digits; other countries need a +country code.';
export function parseAuthIdentifier(input: unknown): { type: 'email' | 'phone'; value: string } | null {
  if (typeof input !== 'string') return null;
  const value = input.trim();
  if (value.includes('@')) {
    if (value.length > 254) return null;
    const parts = value.split('@');
    if (parts.length !== 2) return null;
    const [local, domain] = parts;
    if (!local || local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..')
      || !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return null;
    const labels = domain.split('.');
    if (labels.length < 2 || labels.some((label) => !/^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(label))
      || !/^[a-zA-Z]{2,63}$/.test(labels[labels.length - 1])) return null;
    return { type: 'email', value: value.toLowerCase() };
  }
  if (!/^\+?[0-9 ()-]+$/.test(value) || value.length > 32) return null;
  const digits = value.replace(/[ ()-]/g, '');
  if (!digits.startsWith('+') && !/^[6-9][0-9]{9}$/.test(digits)) return null;
  try {
    const phone = parsePhoneNumberWithError(value, { defaultCountry: 'IN', extract: false });
    const type = phone.getType();
    if (!phone.isValid() || phone.ext || (type !== 'MOBILE' && type !== 'FIXED_LINE_OR_MOBILE')) return null;
    return { type: 'phone', value: phone.number };
  } catch { return null; }
}
